import React, {useState} from 'react';
import "./SupportMain.scss"
import {Button, Col, Collapse, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import {MinusOutlined, PlusOutlined} from "@ant-design/icons";
import {useMediaQuery} from "react-responsive";

const {Panel} = Collapse;

const sectionContent = [
    HowToGetStarted,
    HowToUploadArt,
    HowToAdjustImageDuration,
    HowToPublishArtToPro,
    DiscoverSectionOfPro,
    HowToManageProAccount,
    HowToCreateAndManageArtAlbums,
    changeTheOrientationPro,
    findNewestContent,
    manageAccountInfo
];

function HowToGetStarted() {
    return (
        <div>
            <iframe width="100%" height="auto"
                    src="https://www.youtube.com/embed/PXef0_vXeRs"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                    style={{aspectRatio: '16/10'}}></iframe>
        </div>
    )
}

function HowToUploadArt() {
    return (
        <div>
            <iframe width="100%" height="auto"
                    src="https://www.youtube.com/embed/5rNO5rGccvY"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                    style={{aspectRatio: '16/10'}}></iframe>
        </div>
    )
}

function HowToAdjustImageDuration() {
    return (
        <div>
            <iframe width="100%" height="auto"
                    src="https://www.youtube.com/embed/PyStbjNmtCw"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                    style={{aspectRatio: '16/10'}}></iframe>
        </div>
    )
}

function HowToPublishArtToPro() {
    return (
        <div>
            <iframe width="100%" height="auto"
                    src="https://www.youtube.com/embed/ToodgbtH140"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                    style={{aspectRatio: '16/10'}}></iframe>
        </div>
    )
}

function DiscoverSectionOfPro() {
    return (
        <div>
            <iframe width="100%" height="auto"
                    src="https://www.youtube.com/embed/5kmuO_NsIos"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                    style={{aspectRatio: '16/10'}}></iframe>
        </div>
    )
}

function HowToManageProAccount() {
    return (
        <div>
            <iframe width="100%" height="auto"
                    src="https://www.youtube.com/embed/akZFFWJqT90"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                    style={{aspectRatio: '16/10'}}></iframe>
        </div>
    )
}

function HowToCreateAndManageArtAlbums() {
    return (
        <div>
            <iframe width="100%" height="auto"
                    src="https://www.youtube.com/embed/4j6h3wXrOxQ"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                    style={{aspectRatio: '16/10'}}></iframe>
        </div>
    )
}

function changeTheOrientationPro() {
    return (
        <div>
            <iframe width="100%" height="auto"
                    src="https://www.youtube.com/embed/UPAtd0b3SRw"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                    style={{aspectRatio: '16/10'}}></iframe>
        </div>
    )
}

function findNewestContent() {
    return (
        <div>
            <iframe width="100%" height="auto"
                    src="https://www.youtube.com/embed/DH7-G5mzGLk"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                    style={{aspectRatio: '16/10'}}></iframe>
        </div>
    )
}

function manageAccountInfo() {
    return (
        <div>
            <iframe width="100%" height="auto"
                    src="https://www.youtube.com/embed/2pTt3dF47uQ"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
                    style={{aspectRatio: '16/10'}}></iframe>
        </div>
    )
}

function ProHelpVieuniteApp() {
    const questions = [
        "How to get started",
        "How do I upload Art?",
        "How can I adjust the Image Duration?",
        "How to Publish an Album or Art to my Textura digital canvas?",
        "What can you find in the Discover Section of the Pro Portal?",
        "How do I manage my Textura screen on the Pro Portal?",
        "How do I create and manage Art Albums?",
        "How do I change orientation on the Textura Pro digital canvas?",
        "What’s the best way to find the newest content available?",
        "How can I manage my orders and account information?"
    ]

    const [selection, setSelection] = useState(0);
    const isMobile = useMediaQuery({query: '(max-width: 933px)'});

    return (<div>
        <Layout>
            <Content style={{backgroundColor: '#F0F0F0', fontFamily: "proxima-nova, sans-serif"}}>
                <div className="pro-help-center-top-section">
                    <div className="pro-help-center-text-content">
                        <h2 className={'pro-help-center-subtitle'}>Vieunite Pro
                            Support</h2>
                        <h3 className={'pro-help-center-title'}>How Can We
                            Help?</h3>
                    </div>
                </div>
                <p style={{
                    width: '100%',
                    color: '#6A6A6A',
                    fontSize: '1rem',
                    fontWeight: '400',
                    paddingTop: '2rem',
                    paddingLeft: '8vw'
                }}>
                    <a href='/pro/support' style={{cursor: 'pointer', color: '#6A6A6A'}}>Support</a> / Pro
                    Portal
                </p>

                <div style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingLeft: isMobile ? '3rem' : '11rem',
                    paddingRight: isMobile ? '3rem' : '11rem',
                    paddingTop: '4rem',
                    backgroundColor: '#ffffff',
                }}>
                    <p style={{fontSize: '27px', lineHeight: '34px', fontWeight: '700', margin: '0'}}>Transform Your Business with Curated Art</p>
                    <p style={{fontSize: '22px', lineHeight: '34px', fontWeight: '400', margin: '0', textAlign: 'center'}}>
                        Welcome to the Vieunite Pro App! Unlock a world of curated, high-quality art designed to elevate your business.
                        With intuitive controls, Vieunite Pro enhances your ability to showcase remarkable artworks,
                        fostering stronger brand identity and engagement. Focused on delivering a seamless experience,
                        it empowers you to create impactful, dynamic environments that connect with your audiences
                    </p>
                    <div style={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: 'start',
                        justifyContent: 'center',
                        width: '100%',
                        padding: '4rem 0'
                    }}>
                        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', width: isMobile ? '100%' : '50%', marginRight: isMobile ? '0' : '1.5rem'}}>
                            {sectionContent[selection]()}

                            <div style={{marginBottom: '3rem', marginTop: '2rem', borderRadius: '8px', padding: "1rem", display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#FF810E0D'}}>
                                <h2
                                    style={{
                                        fontWeight: '700',
                                        color: 'black',
                                        display: "flex",
                                        justifyContent: "center",
                                        margin: '0 1rem',
                                    }}>
                                    Request Support
                                </h2>
                                <p
                                   style={{
                                       color: 'black',
                                       textAlign: "center",
                                       paddingLeft: '4rem',
                                       paddingRight: '4rem',
                                   }}>
                                    If you have a question that is not answered here, or you are having any issues with using
                                    your
                                    Textura digital canvas, please get in touch with us today via our support form
                                </p>
                                <button
                                    className="homeMainButton black-border-hover-white"
                                    onClick={_ => window.location.href = '/pro/support/request-support'}
                                    style={{width: "20.5rem"}}>
                                    <p
                                        className={'homeMainButtonLnk homeOverV'} style={{margin: 0}}>
                                        SUPPORT FORM
                                    </p>
                                </button>
                            </div>
                        </div>

                        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', width: isMobile ? '100%' : '50%', marginLeft: isMobile ? '0' : '2rem'}}>
                            {questions.map((question, index) => (
                                <div
                                    onClick={() => setSelection(index)}
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        backgroundColor: selection !== index ? '#D9D9D9' : '#000000',
                                        color: selection !== index ? '#000000' : '#ffffff',
                                        padding: '0.8rem 1.5rem',
                                        marginBottom: '1rem',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        ':hover': {
                                            backgroundColor: selection !== index ? '#BFBFBF' : '#333333'
                                        }
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = selection !== index ? '#BFBFBF' : '#333333';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = selection !== index ? '#D9D9D9' : '#000000';
                                    }}
                                >{question}</div>
                            ))}

                            <button
                                className="homeMainButton black-border-hover-white"
                                onClick={_ => window.location.href = '/pro/support'}
                                style={{width: "100%"}}>
                                <p
                                    className={'homeMainButtonLnk homeOverV'} style={{margin: 0}}>
                                    BACK TO MAIN SUPPORT PAGE
                                </p>
                            </button>
                        </div>
                    </div>
                </div>

                {/*<Row justify={"center"}*/}
                {/*     style={{*/}
                {/*         backgroundColor: 'rgba(122, 6, 59, 0.08)',*/}
                {/*         margin: "2rem 8vw 4rem 8vw",*/}
                {/*         borderRadius: "15px",*/}
                {/*         overflow: "hidden",*/}
                {/*         height: "auto"*/}
                {/*     }}*/}
                {/*>*/}
                {/*    <Col span={10} lg={10} xs={24}>*/}
                {/*        <div style={{*/}
                {/*            marginLeft: '10%', height: '100%', display: 'flex', flexDirection: 'column'*/}
                {/*        }}>*/}
                {/*            <div className='spacer' style={{minHeight: '40px'}}></div>*/}
                {/*            <div style={{*/}
                {/*                display: "flex", flexDirection: "row", alignItems: "center",*/}
                {/*            }}>*/}
                {/*                /!*<img src={YouTubeLogo}/>*!/*/}
                {/*                <h2 className="title-app"*/}
                {/*                    style={{*/}
                {/*                        fontSize: '2rem', textAlign: 'left', lineHeight: 1, margin: 0 // margin: "0 1rem"*/}
                {/*                    }}*/}
                {/*                >*/}
                {/*                    Transform Your Business with Curated Art*/}
                {/*                </h2>*/}
                {/*            </div>*/}

                {/*            <p className="text-content-app"*/}
                {/*               style={{width: '100%', paddingRight: '2rem'}}>*/}
                {/*                Welcome to the Vieunite Pro App! Unlock a world of curated, high-quality art designed to*/}
                {/*                elevate your business. With intuitive controls, Vieunite Pro enhances your ability to*/}
                {/*                showcase remarkable artworks, fostering stronger brand identity and engagement. Focused*/}
                {/*                on delivering a seamless experience, it empowers you to create impactful, dynamic*/}
                {/*                environments that connect with your audiences.*/}
                {/*            </p>*/}
                {/*            <div className='spacer'></div>*/}
                {/*        </div>*/}

                {/*    </Col>*/}

                {/*    <Col span={14} lg={{span: 14}} xs={24}>*/}
                {/*        <div className="iframe-container">*/}
                {/*            <iframe width="640" height="auto"*/}
                {/*                    src="https://www.youtube.com/embed/PXef0_vXeRs"*/}
                {/*                    title="YouTube video player" frameBorder="0"*/}
                {/*                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen*/}
                {/*                    style={{margin: "4rem 2rem", aspectRatio: '16/10'}}></iframe>*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                {/*<Row justify={"center"}*/}
                {/*     style={{*/}
                {/*         // backgroundColor: '#f4f4f4',*/}
                {/*     }}>*/}
                {/*    <Col span={20} lg={20} md={20}>*/}
                {/*        <Collapse expandIconPosition={"end"}*/}
                {/*                  bordered={false}*/}
                {/*                  style={{*/}
                {/*                      backgroundColor: '#f0f0f0', color: '#f4f4f4', border: "none"*/}
                {/*                  }}*/}
                {/*                  expandIcon={(panelProps) => {*/}
                {/*                      if (panelProps.isActive) {*/}
                {/*                          return <MinusOutlined style={{fontSize: '24px', fontWeight: "900"}}/>*/}
                {/*                      } else {*/}
                {/*                          return <PlusOutlined style={{fontSize: '24px', fontWeight: "900"}}/>*/}
                {/*                      }*/}
                {/*                  }}*/}
                {/*        >*/}
                {/*            <Panel header="How do I upload Art?"*/}
                {/*                   className={'help-center-collapse-copy'}*/}
                {/*                   key="1">*/}
                {/*                <div className={'iframe-container'} style={{*/}
                {/*                    display: 'flex',*/}
                {/*                    flexDirection: 'column',*/}
                {/*                    alignItems: 'flex-start',*/}
                {/*                    justifyContent: 'flex-start',*/}
                {/*                    textAlign: 'left',*/}
                {/*                }}>*/}
                {/*                    <p style={{marginBottom: '1em'}}>*/}
                {/*                        Learn how to access and manage your Vieunite Pro account settings, including how to adjust the display duration of images on your Canvas in this simple step-by-step tutorial.*/}
                {/*                    </p>*/}
                {/*                    <iframe width="560" height="auto"*/}
                {/*                            style={{aspectRatio: '16/10'}}*/}
                {/*                            src="https://www.youtube.com/embed/5rNO5rGccvY"*/}
                {/*                            title="YouTube video player" frameBorder="0"*/}
                {/*                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                {/*                </div>*/}
                {/*            </Panel>*/}
                {/*            <Panel header="How can I adjust the Image Duration?"*/}
                {/*                   className={'help-center-collapse-copy'}*/}
                {/*                   key="2">*/}
                {/*                <div className={'iframe-container'} style={{*/}
                {/*                    display: 'flex',*/}
                {/*                    flexDirection: 'column',*/}
                {/*                    alignItems: 'flex-start',*/}
                {/*                    justifyContent: 'flex-start',*/}
                {/*                    textAlign: 'left',*/}
                {/*                }}>*/}
                {/*                    <p style={{marginBottom: '1em'}}>*/}
                {/*                        Learn how to access and manage your Vieunite Pro account settings, including how to adjust the display duration of images on your Canvas in this simple step-by-step tutorial.*/}
                {/*                    </p>*/}
                {/*                    <iframe width="560" height="auto"*/}
                {/*                            style={{aspectRatio: '16/10'}}*/}
                {/*                            src="https://www.youtube.com/embed/PyStbjNmtCw"*/}
                {/*                            title="YouTube video player" frameBorder="0"*/}
                {/*                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                {/*                </div>*/}
                {/*            </Panel>*/}
                {/*            <Panel header="How to Publish an Album or Art to my Textura digital canvas"*/}
                {/*                   className={'help-center-collapse-copy'}*/}
                {/*                   key="3">*/}
                {/*                <div className={'iframe-container'} style={{*/}
                {/*                    display: 'flex',*/}
                {/*                    flexDirection: 'column',*/}
                {/*                    alignItems: 'flex-start',*/}
                {/*                    justifyContent: 'flex-start',*/}
                {/*                    textAlign: 'left',*/}
                {/*                }}>*/}
                {/*                    <p style={{marginBottom: '1em'}}>*/}
                {/*                        Master the art of album creation and management on the Vieunite Pro Portal with this detailed tutorial—learn how to organise your artwork, assign pieces to your screen, access curated collections, and publish albums to Textura Pro.*/}
                {/*                    </p>*/}
                {/*                    <iframe width="560" height="auto"*/}
                {/*                            style={{aspectRatio: '16/10'}}*/}
                {/*                            src="https://www.youtube.com/embed/ToodgbtH140"*/}
                {/*                            title="YouTube video player" frameBorder="0"*/}
                {/*                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                {/*                </div>*/}
                {/*            </Panel>*/}
                {/*            <Panel header="What Can You Find in the Discover Section of the Vieunite Pro Portal?"*/}
                {/*                   className={'help-center-collapse-copy'}*/}
                {/*                   key="4">*/}
                {/*                <div className={'iframe-container'} style={{*/}
                {/*                    display: 'flex',*/}
                {/*                    flexDirection: 'column',*/}
                {/*                    alignItems: 'flex-start',*/}
                {/*                    justifyContent: 'flex-start',*/}
                {/*                    textAlign: 'left',*/}
                {/*                }}>*/}
                {/*                    <p style={{marginBottom: '1em'}}>*/}
                {/*                        Explore the full range of digital art on the Vieunite Pro Portal with this in-depth guide to the hub—discover how to navigate the Artwork, Artists, Playlists, and Galleries sections to find inspiring content for your screen.*/}
                {/*                    </p>*/}
                {/*                    <iframe width="560" height="auto"*/}
                {/*                            style={{aspectRatio: '16/10'}}*/}
                {/*                            src="https://www.youtube.com/embed/5kmuO_NsIos"*/}
                {/*                            title="YouTube video player" frameBorder="0"*/}
                {/*                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                {/*                </div>*/}
                {/*            </Panel>*/}
                {/*            <Panel header="How Do I Manage My Textura Screen on the Vieunite Pro Portal?"*/}
                {/*                   className={'help-center-collapse-copy'}*/}
                {/*                   key="5">*/}
                {/*                <div className={'iframe-container'} style={{*/}
                {/*                    display: 'flex',*/}
                {/*                    flexDirection: 'column',*/}
                {/*                    alignItems: 'flex-start',*/}
                {/*                    justifyContent: 'flex-start',*/}
                {/*                    textAlign: 'left',*/}
                {/*                }}>*/}
                {/*                    <p style={{marginBottom: '1em'}}>*/}
                {/*                        Take control of your Textura digital canvas with this step-by-step guide—learn how to manage your screen, update playlists, and create custom power schedules using the Vieunite Pro Portal.*/}
                {/*                    </p>*/}
                {/*                    <iframe width="560" height="auto"*/}
                {/*                            style={{aspectRatio: '16/10'}}*/}
                {/*                            src="https://www.youtube.com/embed/akZFFWJqT90"*/}
                {/*                            title="YouTube video player" frameBorder="0"*/}
                {/*                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                {/*                </div>*/}
                {/*            </Panel>*/}
                {/*            <Panel header="How Do I Create and Manage Art Albums on the Vieunite Pro Portal?"*/}
                {/*                   className={'help-center-collapse-copy'}*/}
                {/*                   key="6">*/}
                {/*                <div className={'iframe-container'} style={{*/}
                {/*                    display: 'flex',*/}
                {/*                    flexDirection: 'column',*/}
                {/*                    alignItems: 'flex-start',*/}
                {/*                    justifyContent: 'flex-start',*/}
                {/*                    textAlign: 'left',*/}
                {/*                }}>*/}
                {/*                    <p style={{marginBottom: '1em'}}>*/}
                {/*                        Learn how to curate and manage your digital art collection on the Vieunite Pro Portal with this step-by-step tutorial—covering everything from assigning artwork to your screen to accessing curated collections and publishing albums to Textura Pro.*/}
                {/*                    </p>*/}
                {/*                    <iframe width="560" height="auto"*/}
                {/*                            style={{aspectRatio: '16/10'}}*/}
                {/*                            src="https://www.youtube.com/embed/4j6h3wXrOxQ"*/}
                {/*                            title="YouTube video player" frameBorder="0"*/}
                {/*                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                {/*                </div>*/}
                {/*            </Panel>*/}
                {/*            <Panel header="How do I change the orientation on Textura Pro digital canvas?"*/}
                {/*                   className={'help-center-collapse-copy'}*/}
                {/*                   key="7">*/}
                {/*                <div className={'iframe-container'} style={{*/}
                {/*                    display: 'flex',*/}
                {/*                    flexDirection: 'column',*/}
                {/*                    alignItems: 'flex-start',*/}
                {/*                    justifyContent: 'flex-start',*/}
                {/*                    textAlign: 'left',*/}
                {/*                }}>*/}
                {/*                    <p style={{marginBottom: '1em'}}>*/}
                {/*                        This video offers a step-by-step tutorial on how to change the orientation of the Textura Pro digital canvas between landscape and portrait. You’ll learn how to find the screen, select the rotation option, and confirm the change effortlessly.*/}
                {/*                    </p>*/}
                {/*                    <iframe width="560" height="auto"*/}
                {/*                            style={{aspectRatio: '16/10'}}*/}
                {/*                            src="https://www.youtube.com/embed/UPAtd0b3SRw"*/}
                {/*                            title="YouTube video player" frameBorder="0"*/}
                {/*                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                {/*                </div>*/}
                {/*            </Panel>*/}
                {/*            <Panel header="What’s the best way to find the newest content available"*/}
                {/*                   className={'help-center-collapse-copy'}*/}
                {/*                   key="8">*/}
                {/*                <div className={'iframe-container'} style={{*/}
                {/*                    display: 'flex',*/}
                {/*                    flexDirection: 'column',*/}
                {/*                    alignItems: 'flex-start',*/}
                {/*                    justifyContent: 'flex-start',*/}
                {/*                    textAlign: 'left',*/}
                {/*                }}>*/}
                {/*                    <p style={{marginBottom: '1em'}}>*/}
                {/*                        This video offers a step-by-step tutorial on how to access your account details. Learn how to view the newest content and explore artist profiles with ease.*/}
                {/*                    </p>*/}
                {/*                    <iframe width="560" height="auto"*/}
                {/*                            style={{aspectRatio: '16/10'}}*/}
                {/*                            src="https://www.youtube.com/embed/DH7-G5mzGLk"*/}
                {/*                            title="YouTube video player" frameBorder="0"*/}
                {/*                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                {/*                </div>*/}
                {/*            </Panel>*/}
                {/*            <Panel header="How can I manage my orders and account information?"*/}
                {/*                   className={'help-center-collapse-copy'}*/}
                {/*                   key="9">*/}
                {/*                <div className={'iframe-container'} style={{*/}
                {/*                    display: 'flex',*/}
                {/*                    flexDirection: 'column',*/}
                {/*                    alignItems: 'flex-start',*/}
                {/*                    justifyContent: 'flex-start',*/}
                {/*                    textAlign: 'left',*/}
                {/*                }}>*/}
                {/*                    <p style={{marginBottom: '1em'}}>*/}
                {/*                        This video provides a clear step-by-step guide on how to access your account details. Learn how to view your orders, manage account settings, and update your personal information or password.*/}
                {/*                    </p>*/}
                {/*                    <iframe width="560" height="auto"*/}
                {/*                            style={{aspectRatio: '16/10'}}*/}
                {/*                            src="https://www.youtube.com/embed/2pTt3dF47uQ"*/}
                {/*                            title="YouTube video player" frameBorder="0"*/}
                {/*                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                {/*                </div>*/}
                {/*            </Panel>*/}
                {/*        </Collapse>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                {/*<Row justify={"center"}*/}
                {/*     style={{*/}
                {/*         backgroundColor: 'rgba(240, 129, 14, 0.08)',*/}
                {/*         margin: "0 8vw 4vw 8vw",*/}
                {/*         borderRadius: "15px",*/}
                {/*     }}*/}
                {/*>*/}
                {/*    <div style={{padding: "3rem", display: 'flex', flexDirection: 'column', alignItems: 'center'}}>*/}
                {/*        <h2 className="title-app m-text"*/}
                {/*            style={{*/}
                {/*                color: 'black',*/}
                {/*                display: "flex",*/}
                {/*                justifyContent: "center",*/}
                {/*                margin: '0 1rem',*/}
                {/*            }}>*/}
                {/*            Request Support*/}
                {/*        </h2>*/}
                {/*        <p className="text-content-app m-text"*/}
                {/*           style={{*/}
                {/*               color: 'black',*/}
                {/*               textAlign: "center",*/}
                {/*               paddingLeft: '8rem',*/}
                {/*               paddingRight: '8rem',*/}
                {/*               // paddingTop: "1rem",*/}
                {/*               // paddingBottom: "1rem",*/}
                {/*               // margin: '0 1rem',*/}
                {/*           }}>*/}
                {/*            If you have a question that is not answered here, or you are having any issues with using*/}
                {/*            your*/}
                {/*            Textura digital canvas, please get in touch with us today via our support form*/}
                {/*        </p>*/}
                {/*        /!*<button*!/*/}
                {/*        /!*    className="homeMainButton product-access-support-button"*!/*/}
                {/*        /!*    onClick={_ => window.location.href = "/pro/support/request-support"}*!/*/}
                {/*        /!*    style={{width: '30vw', marginTop: '20px'}}*!/*/}
                {/*        /!*>*!/*/}
                {/*        /!*    <a className={'homeMainButtonLnk homeOverV'}>*!/*/}
                {/*        /!*        SUPPORT FORM*!/*/}
                {/*        /!*    </a>*!/*/}
                {/*        /!*</button>*!/*/}
                {/*        <button*/}
                {/*            className="homeMainButton black-border-hover-white"*/}
                {/*            onClick={_ => window.location.href = '/pro/support/request-support'}*/}
                {/*            style={{width: "20.5rem"}}>*/}
                {/*            <p*/}
                {/*               className={'homeMainButtonLnk homeOverV'} style={{margin: 0}}>*/}
                {/*                SUPPORT FORM*/}
                {/*            </p>*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*</Row>*/}
            </Content>
        </Layout>
    </div>)
}

export default ProHelpVieuniteApp;